import { render } from "./RockModal.vue?vue&type=template&id=511182e4&scoped=true&ts=true"
import script from "./RockModal.vue?vue&type=script&lang=ts"
export * from "./RockModal.vue?vue&type=script&lang=ts"

import "./RockModal.vue?vue&type=style&index=0&id=511182e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-511182e4"]])

export default __exports__